import { useEffect, useState } from 'react';

/**
 * useMediaQuery — retourne true quand la media query CSS matche.
 * Sert au design system ndoe pour basculer table (desktop) / cartes (mobile).
 *
 * @param {string} query ex. '(min-width: 768px)'
 * @returns {boolean}
 */
export default function useMediaQuery(query) {
  const get = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener moderne + fallback addListener (vieux Safari)
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return matches;
}

/** Raccourci : true au-dessus du breakpoint tablette (>=768px). */
export function useIsDesktop() {
  return useMediaQuery('(min-width: 768px)');
}
